export default __webpack_public_path__ + "static/media/menu_black_24dp.8684c5a4.svg";